export default __webpack_public_path__ + "static/media/arrow_icon.472f023b.svg";